import i18n from '@/locales/index';

export const importsRoutes = {
	path: 'imports',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'create/:slug',
            name: 'imports-create',
			component: () => import('./pages/create/index.vue'),
			meta: {
				title: ({ route }) => i18n.global.t(`sidebar.${route.params.slug}`),
			},
		},
	],
};
